export {PagesModule} from './pages.module';



// WEBPACK FOOTER //
// ./src/app/pages/index.ts